import React, { useEffect } from 'react';
import { HomeHero } from '../components/home/Hero';
import { IntroSection } from '../components/home/IntroSection';
import { RoofTypes } from '../components/home/RoofTypes';
import { ExpertServices } from '../components/home/ExpertServices';
import { TrustBadges, CompanyTrust } from '../components/home/TrustSections';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { Gallery, Testimonials } from '../components/home/GalleryTestimonials';
import { FaqSection, Brands } from '../components/home/FaqBrands';
import { ScheduleCta, RecentPosts, Coupons } from '../components/home/CtaPostsCoupons';

export default function Home() {
  useEffect(() => {
    document.title = 'Phoenix Roofing & Chimney NJ | Top Rated Local Contractor';
  }, []);

  return (
    <div data-testid="home-page">
      <HomeHero />
      <IntroSection />
      <RoofTypes />
      <ExpertServices />
      <TrustBadges />
      <CompanyTrust />
      <ServicesGrid />
      <Gallery />
      <Testimonials />
      <FaqSection />
      <Brands />
      <ScheduleCta />
      <RecentPosts />
      <Coupons />
    </div>
  );
}
